import { create } from 'zustand';

export interface CartParticle {
  id: string;
  startX: number;
  startY: number;
  productImage?: string;
}

interface CartAnimationStore {
  particles: CartParticle[];
  cartBounce: boolean;
  triggerFly: (startX: number, startY: number, productImage?: string) => void;
  removeParticle: (id: string) => void;
  triggerCartBounce: () => void;
}

export const useCartAnimationStore = create<CartAnimationStore>((set) => ({
  particles: [],
  cartBounce: false,
  triggerFly: (startX, startY, productImage) => {
    const id = `${Date.now()}-${Math.random()}`;
    set((state) => ({
      particles: [...state.particles, { id, startX, startY, productImage }],
    }));
    // Remove particle after animation completes
    setTimeout(() => {
      set((state) => ({
        particles: state.particles.filter((p) => p.id !== id),
      }));
    }, 1100);
    // Trigger cart bounce when particle arrives (~850ms)
    setTimeout(() => {
      set({ cartBounce: true });
      setTimeout(() => set({ cartBounce: false }), 700);
    }, 820);
  },
  removeParticle: (id) =>
    set((state) => ({
      particles: state.particles.filter((p) => p.id !== id),
    })),
  triggerCartBounce: () => {
    set({ cartBounce: true });
    setTimeout(() => set({ cartBounce: false }), 700);
  },
}));
